import { ComponentInstall } from "../../utils";
import Checkbox from "./src";

export default ComponentInstall(Checkbox);
